import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决路由重复导航报错问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    { // 登录
        path: '/login',
        name: 'login',
        component: () => import('@/page/login/index')
    },
    { // 注册
        path: '/register',
        name: 'register',
        component: () => import('@/page/register/index')
    },
    { // 首页 - 学科集合
        path: '/',
        name: 'index',
        component: () => import('@/page/index/index')
    },
    { // 首页 - 案例咨询
        path: '/consultation',
        name: 'consultation',
        component: () => import('@/page/consultation/index')
    },
    // { // 详情
    //     path: '/detail',
    //     name: 'detail',
    //     component: () => import('@/page/detail/index')
    // },
    { // 项目管理
        path: '/project',
        name: 'project',
        component: () => import('@/page/project/index'),
    },
    { // 个人中心
        path: '/personal',
        name: 'personal',
        component: () => import('@/page/personal/index')
    },
    /* ============================= 案例库模块 ================================= */
    { // 案例库模块 —— 案例库页面
        path: '/caseBase/caseBase',
        name: 'caseBase',
        component: () => import('@/page/caseBase/caseBase')
    },
    { // 案例库模块 —— 案例检索页
        path: '/caseBase/search',
        name: 'search',
        component: () => import('@/page/caseBase/search')
    },
    { // 案例库模块 —— 案例详情页
        path: '/caseBase/caseDetail',
        name: 'caseDetail',
        component: () => import('@/page/caseBase/caseDetail')
    },
    { // 案例库模块 —— 期刊列表页
        path: '/caseBase/journalList',
        name: 'journalList',
        component: () => import('@/page/caseBase/journalList')
    },
    { // 案例库模块 —— 期刊详情页
        path: '/caseBase/journalDetail',
        name: 'journalDetail',
        component: () => import('@/page/caseBase/journalDetail')
    },  



    /* ============================= 中文案例库模块 ================================= */
   
    { // 中文案例库模块 —— 中文案例检索页
        path: '/ch_caseBase/search',
        name: 'ch_search',
        component: () => import('@/page/ch_caseBase/search')
    },
    { // 中文案例库模块 —— 中文案例详情页
        path: '/ch_caseBase/caseDetail',
        name: 'ch_caseDetail',
        component: () => import('@/page/ch_caseBase/caseDetail')
    },
    { // 中文案例库模块 —— 中文案例检索页
        path: '/Ces',
        name: 'ces',
        component: () => import('@/page/ch_caseBase/table_chick')
    },
    { // 404页面
        path: '*',
        name: '404',
        component: () => import('@/page/404/index')
    },
    
  ],
})








// WEBPACK FOOTER //
// ./src/router/index.js